import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { ARRAY_SUPPORTED_EDIT_PAGES, REGEX, ROUTES } from '@constants'
import { DEFAULT_TITLE_TAB, TITLE_TABS } from '@constants'

export const useControlTitleTabs = () => {
  const location = useLocation()

  useEffect(() => {
    const matchedPath = Object.keys(TITLE_TABS)
      .sort((a, b) => b.length - a.length)
      .find(
        path =>
          location.pathname === path ||
          (location.pathname.startsWith(`${path}/`) && path !== ROUTES.DEFAULT_PAGE)
      )

    const convertedJSONstring = decodeURIComponent(location.pathname)
    const isViewOrGantPath = REGEX.CHECK_PATH_START_FROM_NUMBER.test(convertedJSONstring)
    const isEditPagePath = ARRAY_SUPPORTED_EDIT_PAGES.some((editPath: string) => {
      return convertedJSONstring.includes(editPath)
    })

    if (isViewOrGantPath) {
      document.title = convertedJSONstring.replace(
        REGEX.DELETE_ALL_SYMBOLS_BEFORE_FIRST_UNDERLINING,
        ' '
      )

      return
    }

    if (isEditPagePath) {
      const newTitleForTab = convertedJSONstring.split('/').pop()
      document.title = newTitleForTab ? newTitleForTab : DEFAULT_TITLE_TAB

      return
    }

    if (matchedPath) {
      document.title = TITLE_TABS[matchedPath]

      return
    }

    document.title = DEFAULT_TITLE_TAB
  }, [location])
}
